import React from 'react'
import forOwn from 'mout/object/forOwn'

export default function Clocks ({clocks}) {
  const clockRow = []
  forOwn(clocks, (val, key) => {
    if (key === 'Composite') {
      clockRow.push(
        <div className='clock composite' key='clocksComposite'>
          <h3>{`Composite: ${val}/10`}</h3>
          <img 
            className='clock' 
            src={`https://bellwork-cg1.firebaseapp.com/img/clock-composite${val}.svg`}
            alt=''
          />
        </div>
      )
    } else {
      const keyLC = key.toLowerCase()
      clockRow.push(
        <div className={`clock sub ${keyLC}`} key={`tm${key}`}>
          <h3>{`${key}: ${val}/10`}</h3>
          <img
            className='clock'
            src={`https://bellwork-cg1.firebaseapp.com/img/clock-${keyLC}${val}.svg`}
            alt=''
          />
        </div>
      )
    }
  })
  
  return (
    <div className='skill-graphs'>
      <div className='reports'>
        {clockRow}
      </div>
    </div>
  )
}


// WEBPACK FOOTER //
// ./src/components/Assessment/AssessPrint/TestTaking/Clocks.js